var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconePercepcao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3014 18.1356C9.40211 18.1356 5.4259 20.1237 5.4259 22.5733C5.4259 24.5614 8.03529 26.2389 11.6387 26.8069V29.6737L15.1889 26.1235L11.6387 22.5733V24.9963C8.84296 24.4993 7.201 23.31 7.201 22.5733C7.201 21.6325 9.89914 19.9106 14.3014 19.9106C18.7036 19.9106 21.4017 21.6325 21.4017 22.5733C21.4017 23.2212 20.1059 24.2508 17.8516 24.8188V26.6383C20.9846 25.9548 23.1768 24.3928 23.1768 22.5733C23.1768 20.1237 19.2006 18.1356 14.3014 18.1356Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4412 -0.0205841C9.77436 -0.0205841 5.99988 3.7539 5.99988 8.42075C5.99988 14.7518 14.4412 24.0975 14.4412 24.0975C14.4412 24.0975 22.8826 14.7518 22.8826 8.42075C22.8826 3.7539 19.1081 -0.0205841 14.4412 -0.0205841ZM14.4414 11.4356C12.7773 11.4356 11.4266 10.085 11.4266 8.42083C11.4266 6.75668 12.7773 5.40607 14.4414 5.40607C16.1056 5.40607 17.4562 6.75668 17.4562 8.42083C17.4562 10.085 16.1056 11.4356 14.4414 11.4356Z",
    fill: "#203864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePercepcao);
export default __webpack_public_path__ + "static/media/IconePercepcao.ecc8f66f023a5fc090d2342eaa8685ec.svg";
export { ForwardRef as ReactComponent };